<template>
  <EmailAddressVisible />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
